import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  colorLandingBrand,
  colorLandingBrandStrong,
  colorLandingMuted,
  colorLandingBarInactive,
} from "src/design/tokens";

// Covers per time slot; `targeted` marks the window an offer is aimed at and
// `highlighted` the slots that filled up as a result.
const BARS = [
  { hour: "13h", height: 55, targeted: false, highlighted: false },
  { hour: "14h", height: 70, targeted: false, highlighted: false },
  { hour: "15h", height: 44, targeted: true, highlighted: false },
  { hour: "16h", height: 62, targeted: true, highlighted: true },
  { hour: "17h", height: 78, targeted: true, highlighted: true },
  { hour: "18h", height: 64, targeted: false, highlighted: false },
  { hour: "20h", height: 90, targeted: false, highlighted: false },
  { hour: "21h", height: 96, targeted: false, highlighted: false },
];

/** Bar profile with the dashed targeted window, for the off-peak tab. */
export const OffPeakMedia = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: 12,
          color: colorLandingMuted,
          mb: 1.5,
        }}
      >
        <Typography sx={{ fontSize: 12 }}>
          {t("landingPage.showcase.offPeak.coversPerSlot")}
        </Typography>
        <Typography sx={{ fontSize: 12, color: colorLandingBrandStrong }}>
          {t("landingPage.showcase.offPeak.targetWindow")}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", gap: 0.875, alignItems: "flex-end", height: 120 }}>
        {BARS.map((bar) => (
          <Box
            key={bar.hour}
            sx={{
              flex: 1,
              position: "relative",
              height: `${bar.height}%`,
              borderRadius: "5px 5px 3px 3px",
              background: bar.highlighted
                ? `linear-gradient(180deg, ${colorLandingBrand}, ${colorLandingBrandStrong})`
                : colorLandingBarInactive,
            }}
          >
            {bar.targeted && (
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  border: `1.5px dashed ${colorLandingBrand}`,
                  borderRadius: "8px",
                  pointerEvents: "none",
                }}
              />
            )}
          </Box>
        ))}
      </Box>
      <Box sx={{ display: "flex", gap: 0.875, mt: 1 }}>
        {BARS.map((bar) => (
          <Typography
            key={bar.hour}
            sx={{ flex: 1, textAlign: "center", fontSize: 10, color: colorLandingMuted }}
          >
            {bar.hour}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};
